import React, { useEffect, useState } from 'react';
import CommonService from '../../../../services/commonService';
import getIcons from '../../functions/getIcons/getIcons';

const header_links = [
  {
    label: 'Compra tu pasaje',
    url: '/',
    active: false,
    id: 1,
  },
  {
    label: 'Empresa',
    active: false,
    url: '/company-ahumada',
    id: 2,
  },
  {
    label: 'Oficinas',
    url: '/offices-ahumada',
    active: false,
    id: 3,
  },
  {
    label: 'Trabaja con nosotros',
    url: '/work-with-us',
    active: false,
    id: 4,
  },
  {
    label: 'Términos y Condiciones',
    active: false,
    id: 5,
    url: '',
    sublinks: [
      {
        id: 5,
        label: 'Requisitos para viajar a Mendoza',
        url: '/travel-to-mendoza',
      },
      {
        id: 5,
        label: 'Reglamento ',
        url: '/regulation',
      },
      {
        id: 5,
        label: 'Condiciones de equipaje',
        url: '/baggage',
      },
    ],
  },
  {
    label: 'Contacto',
    active: false,
    id: 6,

    url: '/contact-ahumada',
  },
];

const header_links_thaebus = [
  {
    label: 'Compra tu pasaje',
    url: '/',
    active: false,
    id: 1,
  },
  {
    label: 'Empresa',
    active: false,
    url: '/company-thaebus',
    id: 2,
  },
  {
    label: 'Oficinas',
    url: '/offices-thaebus',
    active: false,
    id: 3,
  },
  // {
  //   label: 'Trabaja con nosotros',
  //   url: '/work-with-us',
  //   active: false,
  //   id: 4,
  // },
  {
    label: 'Términos y Condiciones',
    active: false,
    id: 5,
    url: '/tnc-thaebus',
  },

  {
    label: 'Políticas de privacidad',
    active: false,
    id: 7,
    url: '/privacy-policy',
  },

  {
    label: 'Contacto',
    active: false,
    id: 6,

    url: '/contact-thaebus',
  },
];

const ThemeNineHeader = ({ history, operator, onMyAccountClick, loginData, t }) => {
  const [state, setState] = useState(header_links_thaebus);

  const getId = () => {
    const url = window.location.pathname;
    let id;
    if (url === '/') {
      return (id = 1);
    }
    if (url === '/company-thaebus') {
      return (id = 2);
    }
    if (url === '/offices-thaebus') {
      return (id = 3);
    }
    if (url === '/work-with-us') {
      return (id = 4);
    }
    if (url === '/tnc-thaebus') {
      return (id = 5);
    }
    if (url === '/contact-thaebus') {
      return (id = 6);
    }
    if (url === '/privacy-policy') {
      return (id = 7);
    }
    if (url === '/contact-ahumada') {
      return (id = 8);
    }
    if (url === '/offices-ahumada') {
      return (id = 9);
    }
  };

  useEffect(() => {
    console.log('===id', getId());
    handleNavigation(getId());
  }, []);

  const handleNavigation = id => {
    const newHeader_links = state.map(item => {
      item.active = item.id === id ? true : false;
      return item;
    });
    setState(newHeader_links);
  };
  return (
    operator && (
      <div className="themes-theme-nine-header ">
        <div className="logo_navbar">
          <div className="new-container top-strip-nav-container">
            <div className="logo-img">
              <a href="/">
                <img
                  src={operator && operator.header_logo}
                  alt=""
                  style={{
                    width: operator.header_logo_width ? operator.header_logo_width : '',
                    height: 'auto',
                  }}
                />
              </a>
            </div>

            {/* <div className=" logo-contact">
              <div className="contact-info">
                <img src={getIcons('phone')} style={{ width: '15px' }} />
                <span className="header-telephone">
                  <a href="tel:#">{operator && operator.phone_number}</a>
                </span>
              </div>
              <div className="my-tickets bold-text">Colaboradores</div>
              <div className="triangle-and-links">
                
                <div className="colaborator-container">
                  <div className="triangle"></div>
                  <div className='link'>
                    <a href=" http://www.busesahumada.cl/sgc/" target="_blank">Intranet</a>
                  </div>
                  <div className='link'>
                    <a
                      href="https://clients.geovictoria.com/account/login?ReturnUrl=%2f
"
                      target="_blank"
                    >Gestión de asistencia</a>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <style>
          .nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
          margin-top:270px;
          {'}'}
          .nav-section.home-nav-section.common-top-strip.header-box.payments-page-header + * {'{'}
          margin-top:140px !important;
          {'}'}
        </style>
        <div className="nav ">
          <div className="nav-wrapper new-container">
            {state.map((val, i) => {
              return (
                <div
                  className={`nav-item ${val.active ? 'active' : ''}`}
                  onClick={() => {
                    val.url && handleNavigation(val.id);
                    val.url && history.push(val.url);
                  }}
                  key={i}
                >
                  {val.label}

                  {val.sublinks && (
                    <div className="sub-nav">
                      {val.sublinks &&
                        val.sublinks.map((sub, i) => {
                          return (
                            <div
                              className={`sub-nav-item ${
                                sub.url == window.location.pathname ? 'active-sub-link' : ''
                              }`}
                              onClick={() => {
                                console.log('sub', sub);
                                handleNavigation(sub.id);
                                sub.url && history.push(sub.url);
                              }}
                              key={i}
                            >
                              {sub.label}
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              );
            })}

            {operator && operator.has_user_account && (
              <ul
                style={{ marginLeft: 20 }}
                // className="header-login-icon-container"
              >
                <li>
                  <div className="my-account-top font10">
                    <a onClick={onMyAccountClick}>
                      {CommonService.isLoggedIn(loginData) && loginData.image_link ? (
                        <div className="dp-image-top">
                          <img src={loginData.image_link} alt="DIS" />
                        </div>
                      ) : (
                        <div
                          className={
                            'menu-profile-icon-stripe circular-icon-stripe profile-circular-icon '
                          }
                        >
                          <img
                            src={getIcons('userIcon', operator)}
                            // src="/images/user_red_dot.svg"
                            alt={t('TRANSLATIONS.USER_DOT')}
                          />
                        </div>
                      )}
                      {/* {CommonService.isLoggedIn(this.props.common.loginData)
                          ? CommonService.capitalize(this.props.common.loginData.name)
                          : t('HOME.MY_ACCOUNT')} */}
                    </a>
                    {/* {this.state.showMyAccountDropDown ? this.renderMyAccountDropdown(t) : null} */}
                  </div>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default ThemeNineHeader;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/common/ThemeNineHeader.js